<template>
  <div class='floor'>
    <div class='floor_area'>
      <div class="zoomIcon" @click="handleZoom"></div>
      <!--:floorData="floorMapData"-->
      <floorMap :height="floorHeight" ref="childrenFloorMap" :isStatus="isStatus"></floorMap>
      <div class='mask' v-if='alarmList.length>0'>
        <div class='alarm_box'>
          <alarmBox  @deal='is_receive' :alarmContent='alarmList' @showDeatil='alarmDetail'></alarmBox>
        </div>
      </div>
      <div>
        <audio id='audio2'  preload='auto' style='display:none'>
          <source src="https://gas95.oss-cn-beijing.aliyuncs.com/monitor/static/mp3/baojing.mp3" type='audio/mpeg'>
        </audio>
      </div>
      <dialogItem :show-dialog="showDialog" @closeDialog='closeDialog' :dialogData='detail' @close_alarm='clear_alarm'></dialogItem>

    </div>
  </div>
</template>

<script>
  import {mapState, mapMutations} from 'vuex';
  import qipao from './qipao'
  import deviceList from './device_list'
  import alarmBox from '../alarm/alarm_box.vue';
  import dataUrl from '../../../libs/js/interfaceAddress.js';
  import dialogItem from "../../../components/dialog/dialogs.vue"

  import floorMap from "./floor_map.vue"
  export default{
    props:{
      isStatus:{
        type: Boolean,
        default: () => {
          return false
        }
      },
      lineType:{
        type: String,
        default: () => {
          return ''
        }
      },

    },
    data(){
      return{
        floorHeight:'0px',   //民品地图的高
        showDialogList:false,
        showDialog:false,
        floorMapData:null, //楼层及设备数据量
        //报警信息
        alarmList: [
          // {
          //     alarmType: "浓度报警",
          //     alarmTypeId:1,
          //     deviceId: "352425025106405",
          //     realPos: "西里小区32号北侧",
          //     user: "暂无",
          //     phone: "暂无"
          // },{
          //     alarmType: "压力报警",
          //     alarmTypeId:1,
          //     deviceId: "352425025106405",
          //     realPos: "西里小区32号北侧",
          //     user: "暂无",
          //     phone: "暂无"
          // }
        ],
        clearMesInterval:null,
        //弹框详情dialog
        showDialog:false,
        params:{},
        detail:{
          alarmDetailData:{},
          deviceData:{},
          mesData:{},
          presData:{}
        },
        //民品地图状态
        map_status:null,
      }
    },
    components:{
      qipao,
      deviceList,
      alarmBox,
      dialogItem,
      floorMap
    },
    computed:{
      ...mapState(['onMessageArrived']),
    },
    mounted(){
      this.$bus.$off('emitter-excub-sign-out-event').$on('emitter-excu-sign-out-event',this.close_audio);
      let that = this;
      setTimeout(() => {
        //根据页面调整高度
        that.onWindowResize()
        window.addEventListener('resize',function(){
          that.onWindowResize();
        })
      }, 10);
      this.$nextTick(()=>{
        this.pageInit();
      });

    },
    watch:{
      isStatus:{
        handler(newVal,oldVal){
          this.map_status = newVal;
        }
      },
      //mqtt推过来数据的处理
      onMessageArrived:{
        handler(newVal,oldVal){
          if(this.isStatus === false){
            return false
          }
          try{
            var newInfo = typeof newVal == 'string' ? JSON.parse(newVal) : newVal;
            if(newInfo.type == 'onlineNotice'){
              this.pageInit();
            } else if(newInfo.type == 'offlineNotice'){
              this.pageInit();
              //设备下线的时候 关音乐 关报警弹框
              this.alarmList.forEach((_item,_index)=>{
                if(_item.deviceId == newInfo.deviceId){
                  this.alarmList.splice(_index,1);
                }
              });
              if(this.alarmList.length === 0){
                window.baojingmp3_Mgaode.pause();
                clearInterval(this.clearMesInterval);
              }
            } else if(newInfo.type =='eventReport'){

            }else if(newInfo.type=='emergencyAlarm'){
              this.$bus.$emit('get-alarmList-bus');
              //先清除之前的
              window.baojingmp3_Mgaode.pause();
              clearInterval(this.clearMesInterval);

              window.baojingmp3_Mgaode.play();
              this.clearMesInterval=setInterval(()=>{
                window.baojingmp3_Mgaode.play();
              },1000);
              let newValInfo = this.alarmList.filter((_item) => {
                if(_item.deviceId == newInfo.deviceId&& _item.alarmTypeId==newInfo.alarmTypeId){
                  return _item;
                }
              })
              if(newValInfo.length === 0){
                this.alarmList.push(newInfo);
              }
            } else if(newInfo.type=='emergencyAlarm'){
              this.$bus.$emit('get-alarmList-bus');
              //先清除之前的
              window.baojingmp3_Mgaode.pause();
              clearInterval(this.clearMesInterval);

              window.baojingmp3_Mgaode.play();
              this.clearMesInterval=setInterval(()=>{
                window.baojingmp3_Mgaode.play();
              },1000);

              let newValInfo = this.alarmList.filter((_item) => {
                if(_item.deviceId == newInfo.deviceId&& _item.alarmTypeId==newInfo.alarmTypeId){
                  return _item;
                }
              })
              if(newValInfo.length === 0){
                this.alarmList.push(newInfo);
              }
            }else if(newInfo.type == 'clearAlarm'){
              this.alarmList.forEach((_item,_index)=>{
                if(_item.deviceId == newInfo.deviceId && _item.alarmTypeId==newInfo.alarmTypeId){
                  this.alarmList.splice(_index,1);
                }
              });
              if(this.alarmList.length === 0){
                window.baojingmp3_Mgaode.pause();
                clearInterval(this.clearMesInterval);
              }
            }

          } catch(e){
            console.log(e)
          }
        },
        deep:true
      }
    },
    methods:{
      ...mapMutations(['set_devToday','set_onlineNum','set_valveOpen']),

      //处理放大缩小 隐藏左右
      handleZoom(){
        this.$emit('handleZoom')
      },
      onWindowResize(){
        let pageHeight = document.documentElement.clientHeight; //页面总高度
        if(document.querySelectorAll(".floor_area") && document.querySelectorAll(".floor_area")[0]){
          document.querySelectorAll(".floor_area")[0].style.height =  pageHeight - 270 + 'px';  //在这里可以根据你的边距做调整
          this.floorHeight = document.querySelectorAll(".floor_area")[0].style.height;
        }
      },
      /**
       * 关闭报警音乐
       *
       * */
      close_audio(){
        window.baojingmp3_Mgaode = document.getElementById('audio2');
        window.baojingmp3_Mgaode.pause();
      },
      pageInit(){
        if(this.map_status === false){
          return false
        };
        window.baojingmp3_Mgaode = document.getElementById('audio2');
        this.$http.get(dataUrl.interfaceAddress.devAllUrl, {}).then(res => {
          if(res.data&&res.data.code ===1){

            if(res && res.data && res.data.data){
              console.log('民品高德地图数据-=-=--=-=-=-=-=-='+ JSON.stringify(res.data.data));

              //民品楼层数据
              this.floorMapData = res.data.data;
              this.$refs['childrenFloorMap'].handleFloorData(res.data.data);

              //图表数据
              let devToday = res.data.data.devToday;

              let todayDev = [];
              if(JSON.stringify(devToday) !== "{}"){

                todayDev = [
                  {
                    // alarmDev:devToday.alarmDev,
                    onlineDev:devToday.onlineDev,
                    totalDev:devToday.totalDev,
                  }
                ];
              } else {
                todayDev = [
                  {
                    // alarmDev:0,
                    onlineDev:0,
                    totalDev:0,
                  }
                ];
              }

              //民品开阀数
              if(devToday.valveOpen !== undefined){
                this.set_valveOpen(devToday.valveOpen);
              } else {
                var valveNum= 0;
                this.set_valveOpen(valveNum);
              }
              this.set_devToday(todayDev);

              if (this.lineType=='6'){
                this.set_onlineNum(devToday.offlineDev);
              }else
              {
                this.set_onlineNum(devToday.onlineDev);
              }
               //报警列表
              if(!res.data.data.alarmList){
                return
              }
              if(res.data.data.alarmList.length>0){
                window.baojingmp3_Mgaode.pause();
                clearInterval(this.clearMesInterval);
                window.baojingmp3_Mgaode.play();
                this.clearMesInterval=setInterval(()=>{
                  window.baojingmp3_Mgaode.play();
                },1000)
                if(res.data.data.alarmList && Array.isArray(res.data.data.alarmList)){
                  this.alarmList = res.data.data.alarmList;
                  // if(this.alarmList.length === 2) {
                  //     this.alarmList.push(res.data.data.alarmList[0]);
                  //     this.alarmList.push(res.data.data.alarmList[1]);
                  // }
                }else{
                  window.baojingmp3_Mgaode.pause();
                  clearInterval(this.clearMesInterval);
                  throw new Error('alarmList is not Array')
                }
              } else{
                window.baojingmp3_Mgaode.pause();
                clearInterval(this.clearMesInterval);
              }

            }else{
              throw new Error('The interface return format is incorrect');
              let todayDev = [
                {
                  alarmDev:0,
                  onlineDev:0,
                  totalDev:0,
                }
              ];
              this.set_devToday(todayDev);
            }
          }

        }).catch((err) => {
          console.log(err)
          // reject(err)
        })
      },
      //是否接警
      is_receive(item,index){
        // console.log("接受当前预警信息",item,index);
        // 请求接口 成功后 重新获取新数据

        this.getIsReceiveFunc(item);
        // this.page_init();
      },
      //接警处理
      getIsReceiveFunc(item){
        this.$http.post(dataUrl.interfaceAddress.answerAlarmUrl, {
          deviceId:item.deviceId || '',
          alarmTypeId:item.alarmTypeId || '',
        }).then(res => {
          // code=1时弹框小时，code=2时弹框继续显示，description 为提示语
          if(res.data&&res.data.code==1){
            this.alarmList.forEach((_item,_index)=>{
              if(_item.deviceId == item.deviceId && _item.alarmTypeId==item.alarmTypeId){
                this.alarmList.splice(_index,1);
              }
            })
            let message=res.data.description;
            this.$message({
              message: message,
              type: 'success'
            });
            if(this.alarmList.length<=0){
              window.baojingmp3_Mgaode.pause();
              clearInterval(this.clearMesInterval);
            }
            this.$bus.$emit('get-alarmList-bus');

          } else {
            let message=res.data.description;
            this.$message.error(message);
          }
          // this.page_init();
        }).catch((err) => {
          console.log(err)
        })
      },

      //** /获取弹框的详情 **//

      //关闭弹窗
      closeDialog(){
        this.showDialog = false;
      },
      //获取详情
      alarmDetail(item,index){
        // this.showDialog = true;
        let params= {
          deviceId:item.deviceId || '',
          alarmTypeId:item.alarmTypeId || '',
          // deviceId:'863703031868917',
          // alarmTypeId:'1',
        }
        this.params = params;
        this.dialog_bottom_data();
      },
      //详情浓度曲线
      dialog_mes_data(){
        //  historyMes:context +'/getDev/historyMes',  //二级页面浓度曲线
        this.$http.post(dataUrl.interfaceAddress.historyMes, this.params).then(res => {
          //  console.log(res.data.data,'浓度数据')
          if(res.data.data&&res.data.code===1){
            this.detail.mesData = res.data.data;

          }
        }).catch((err) => {
          console.log(err)
        })
      },
      //详情压力曲线
      dialog_pres_data(){
        //   historyPres:context +'/getDev/historyPres',  //二级页面压力曲线
        console.log('压力数据-=-=-=data')

        this.$http.post(dataUrl.interfaceAddress.historyPres, this.params).then(res => {
          //  console.log(res.data.data,'压力数据')
          if(res.data.data&&res.data.code===1){
            this.detail.presData = res.data.data;
          }
        }).catch((err) => {
          console.log(err)
        })
      },
      //详情中间的内容
      dialog_device_data(){
        //  nowState:context +' /getDev/nowState',  //二级页设备信息实时数据
        this.$http.post(dataUrl.interfaceAddress.nowState, this.params).then(res => {
          //  console.log(res.data.data,'设备数据')
          if(res.data.data&&res.data.code===1){
            this.detail.deviceData = res.data.data;
          }
        }).catch((err) => {
          console.log(err)
          // reject(err)
        })
      },

      //详情最下面的条目内容
      dialog_bottom_data(){
        this.$http.post(dataUrl.interfaceAddress.infoDetail, this.params).then(res => {
          // console.log(res.data.data,'获取的报警数据详情');
          if(res.data.code===1){
            if(res.data.data){
              this.showDialog = true;
              this.detail.alarmDetailData = res.data.data;
              //获取图表数据
              this.dialog_mes_data();
              this.dialog_pres_data();
              this.dialog_device_data();
            } else {
              let message=res.data.description;
              this.$message.error(message);
            }
          } else {
            this.showDialog = false;
            let message=res.data.description;
            this.$message.error(message);
          }
        }).catch((err) => {
          console.log(err)
          // reject(err)
        })
      },
      //详情中手动解除报警
      clear_alarm(){
        this.showDialog = false;
        this.$http.post(dataUrl.interfaceAddress.clearAlarmTask, this.params).then(res => {
          if(res.data&&res.data.code==1){
            let message=res.data.description;
            this.$message({
              message: message,
              type: 'success'
            });
            this.alarmList.forEach((_item,_index)=>{
              if(_item.deviceId == this.params.deviceId && _item.alarmTypeId==this.params.alarmTypeId){
                this.alarmList.splice(_index,1);

              }
            });
            if(this.alarmList.length<=0){
              window.baojingmp3_Mgaode.pause();
              clearInterval(this.clearMesInterval);
            }
            this.$bus.$emit('get-alarmList-bus');
          } else {
            let message=res.data.description;
            this.$message.error(message);
          }

        }).catch((err) => {
          console.log(err)
        })

      },

      //** /获取弹框的详情 **//
    },
    destory(){
      window.onresize = null;
      clearInterval(this.clearMesInterval);   //清除音乐的定时器
    },
    beforeDestroy(){
      window.removeEventListener('resize',this.onWindowResize);
      this.$eventBus.$off('emitter-excu-sign-out-event',this.close_audio);
    },
  }


</script>

<style lang="less" scoped>
  .floor{
    text-align: center;
    width: 100%;
    .floor_area{
      margin: 30px 10px 0px 10px;
      /*background: url(../../../../static/img/civil_bg1.jpg) no-repeat;*/
      background-size: 100% 100%;
      position: relative;
      .zoomIcon{
        width: 20px;
        height: 20px;
        background: url(https://gas95.oss-cn-beijing.aliyuncs.com/monitor/static/img/shrink.png) no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 10;
        cursor: pointer;
      }
      .mask{
        width: 99.7%;
        height: 99.7%;
        background: #04022b;
        opacity: 0.8;
        z-index:10;
        position: absolute;
        margin: 1px;
        top: 0px;

        .alarm_box{
          width:614px;
          height: 314px;
          // opacity: 0.5;
          position: fixed;
          top:50%;
          left:50%;
          margin:-157px 0 0 -307px;
          z-index: 22;
        }
      }
      .qipao_item{
        display: inline-block;
        z-index: 9;
      }

    }

  }
</style>



// WEBPACK FOOTER //
// src/page/main_content/floor_distribution/floor_main.vue